import React from 'react';

export default function ({ children,width }) {
    return (
        <th
            role="columnheader"
            data-p-sortable-column="false"
            data-p-resizable-column="false"
            data-p-filter-column="false"
            data-p-frozen-column="false"
            data-p-reorderable-column="false"
            data-pc-name="datatable"
            data-pc-section="headercell"
            style={{width:width}}
        >
            <div className="p-column-header-content" data-pc-section="headercontent">
                <span className="p-column-title" data-pc-section="headertitle">
                    {children}
                </span>
            </div>
        </th>
    );
}
